import AllFilter from './AllFilter'
import SortableListPersistence from '../react/SortableListPersistence'

export default class ArticlePubFilter extends AllFilter {
  setupLocalPersistance() {
    this.persistence = new SortableListPersistence({objectref: `${this.params.territoryId}-${this.selector}`})
    this.filter = this.persistence.getSortKey() || "all";
  }

  filterJobs(data) {
    let filtered = [];
    $.each(data, (idx, job) => {
      if (this.filter == "all" || job.publication_ids.includes(this.filter)) {
        filtered.push(job);
      }
    });
    return filtered;
  }
}
